import React, { Component } from 'react';
import {connect} from 'react-redux'
import flow from 'lodash/flow'

import { withStyles } from 'material-ui/styles';
import Drawer from 'material-ui/Drawer'

import MenuItems from './MenuItems'
import {closeDrawer} from '../../actions'
import {getDrawerOpen} from '../../selectors'
import logo from '../../img/logo.svg'

class Menu extends Component
{
    onCloseDrawer = () => {
        this.props.handleCloseDrawer();
    };

    render()
    {
        const {classes, theme, show, drawerOpen} = this.props;
        return <div className={classes.container}>
            <Drawer
                type="temporary"
                anchor={'left'}
                open={drawerOpen}
                className={classes.mobileDrawer}
                classes={{
                    paper: classes.drawerPaper,
                }}
                onRequestClose={this.onCloseDrawer}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
            >
                <div className={classes.drawerHeader}>
                    <img src={logo} alt="Evoenergy Logo" />
                </div>
                <MenuItems theme={theme} />
            </Drawer>
            <div className={classes.drawerContainer}>
                <Drawer
                    type={'persistent'}
                    open={show}
                    className={classes.desktopDrawer}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                >
                    <div className={classes.drawerHeader}>
                        <img src={logo} alt="Evoenergy Logo" />
                    </div>
                    <MenuItems theme={theme} className={classes.fixedMenuItems}/>
                </Drawer>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        drawerOpen: getDrawerOpen(state),
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        handleCloseDrawer: () => {
            dispatch( closeDrawer() );
        },
    }
}

const drawerWidth = 250;

var styles = theme => ({
    container: {
        position: 'fixed',
        height: '100vh',
    },
    drawerContainer: {
        zIndex: theme.zIndex.menu,
        height: '100%'
    },
    mobileDrawer: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none'
        }
    },
    desktopDrawer: {
        display: 'none',
        height: '100%',
        [theme.breakpoints.up('md')]: {
            display: 'flex'
        }
    },
    drawerHeader: {
        ...theme.mixins.toolbar,
        paddingTop: 6,
        boxSizing: 'border-box',
        //backgroundColor: theme.palette.primary['900'],
        display: 'flex',
        padding: '0 20px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.3)',
        '& img': {
            width: 180,
            height: 57,
        }
    },
    drawerPaper: {
        width: drawerWidth,
        backgroundColor: theme.palette.primary['500'],
        color: 'white',
        [theme.breakpoints.up('md')]: {
            position: 'relative',
            height: '100%',
            //marginTop: 64,
        },
    },
    fixedMenuItems: {
        //position: 'fixed',
        //width: drawerWidth
    }

});

export default flow([
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
])(Menu)


// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js